import { ReturnHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, Stack } from '@mui/material';

interface CreateNewDashboardDialogActionsProps {
  onClose: () => void;
  isCreateDisabled: boolean;
  isLoading: boolean;
}

export const CreateNewDashboardDialogActions = ({
  onClose,
  isCreateDisabled,
  isLoading,
}: CreateNewDashboardDialogActionsProps) => {
  return (
    <DialogActions>
      <Stack direction="row" m={1} spacing={2}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <LoadingButton
          disabled={isCreateDisabled}
          loading={isLoading}
          variant="contained"
          type="submit"
          autoFocus
          endIcon={<ReturnHotKeyIcon isDisabled={isCreateDisabled} />}
        >
          Create
        </LoadingButton>
      </Stack>
    </DialogActions>
  );
};
